export default __webpack_public_path__ + "static/media/Dissulutus Bracers.f50c7cf2.jpg";